import React, { SVGProps } from 'react'

const INJUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none' {...props}>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
    <g clipPath='url(#clip0_3876_22967)'>
      <path
        d='M12.0449 12.763C12.252 12.5035 12.4716 12.2514 12.6912 12.0019C12.7011 11.9894 12.7236 11.9869 12.7336 11.9745C12.7535 11.9495 12.786 11.9345 12.8059 11.9096L12.8259 11.8846C12.9781 11.7424 13.1428 11.5902 13.3299 11.4554C13.9937 10.9514 14.6824 10.5671 15.411 10.3151C17.7416 9.49666 20.3367 10.0007 22.3728 11.9221C25.2149 14.587 24.9604 18.8764 22.6922 21.7285C19.8251 25.9804 14.8995 31.9116 21.719 37.2265C22.9467 38.1822 23.855 38.9707 27.7176 40.0861C25.1899 40.5527 22.8494 40.408 20.2418 39.7418C18.3978 38.7013 15.4983 36.473 14.5102 33.4612C13.018 28.8949 17.1352 22.0703 19.124 19.4428C21.8563 15.8047 17.4347 11.8672 14.1808 16.2638C12.4791 18.5545 9.5047 25.0397 10.5377 29.848C11.1416 32.5754 11.9476 34.5641 15.144 37.2939C14.5526 36.9446 13.9762 36.5478 13.4173 36.1037C5.99387 29.1868 6.85723 18.4946 12.0449 12.763Z'
        fill='url(#paint0_linear_3876_22967)'
      />
      <path
        d='M37.3167 34.5955C37.1096 34.855 36.89 35.107 36.6705 35.3565C36.6605 35.369 36.638 35.3715 36.628 35.384C36.6081 35.4089 36.5756 35.4239 36.5557 35.4489L36.5357 35.4738C36.3835 35.6161 36.2188 35.7683 36.0317 35.903C35.3679 36.4071 34.6767 36.7913 33.9506 37.0433C31.62 37.8618 29.025 37.3577 26.9888 35.4364C24.1467 32.7714 24.4012 28.4821 26.6694 25.63C29.5365 21.3781 34.4622 15.4468 27.6401 10.1319C26.4149 9.17622 25.5042 8.38771 21.6415 7.27233C24.1692 6.80571 26.5097 6.95044 29.1173 7.61667C30.9613 8.6572 33.8608 10.888 34.8489 13.8973C36.3411 18.4636 32.2239 25.2881 30.2352 27.9157C27.5029 31.5538 31.9245 35.4913 35.1783 31.0946C36.8801 28.804 39.8544 22.3188 38.8214 17.5104C38.2175 14.7831 37.4116 12.7943 34.2151 10.0645C34.8065 10.4139 35.3829 10.8106 35.9418 11.2548C43.3653 18.1692 42.5044 28.8639 37.3167 34.5955Z'
        fill='url(#paint1_linear_3876_22967)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_3876_22967'
        x1='8.00006'
        y1='25.1495'
        x2='41.3618'
        y2='25.1495'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#0082FA' />
        <stop offset='1' stopColor='#00F2FE' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_3876_22967'
        x1='7.99986'
        y1='22.2115'
        x2='41.3616'
        y2='22.2115'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#0082FA' />
        <stop offset='1' stopColor='#00F2FE' />
      </linearGradient>
      <clipPath id='clip0_3876_22967'>
        <rect width='33' height='34' fill='white' transform='translate(8 7)' />
      </clipPath>
    </defs>
  </svg>
)

export default INJUSD
